import React from 'react';
import { useFilterItems } from '../../services/filterItemsBuilder';
import { Table } from '../../../base/Table';
import { useReviseFilterValue } from '../../services/reviseFilterValue';

const SelectFilter = ({ name, multiple = false }) => {
  const { data, ids } = useFilterItems(name) || {};

  useReviseFilterValue({ name, ids, multiple });

  if (!ids || ids.size <= 1) {
    return null;
  }

  return <Table.Filter name={name} multiple={multiple} items={data} />;
};

export default SelectFilter;
